import { FC } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import SkillAssessmentTable from './SkillAssessmentTable';
import { useAppSelector } from '../../redux/hooks';
import { selectedCsvProcess } from '../../redux/reducers/csvProcessSlice';

interface Props {
  miamiBrand: boolean;
}
const AssessmentHistoryTables: FC<Props> = ({ miamiBrand }) => {
  const isCsvProcessing = useAppSelector(selectedCsvProcess);
  return (
    <div className="nc_block w-full mb-8">
      <TabView className="col-12 nc_tabView">
        <TabPanel header={miamiBrand ? 'Skill Challenge History' : 'Skill Assessments'} disabled={isCsvProcessing}>
          <SkillAssessmentTable />
        </TabPanel>
      </TabView>
    </div>
  );
};

export default AssessmentHistoryTables;
